<template>
  <div class="bg">
    <div class="login">
      <div class="message">{{title}}-后台登录</div>
      <div id="darkbannerwrap"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="账号登录" name="first">
          <div style="margin-top: 20px;">
            <input name="username" placeholder="用户名" v-model="LoginName" type="text">
            <hr class="hr15">
            <input name="password" placeholder="密码" v-model="Pwd" type="password">
            <hr class="hr15">
            <input value="登录" style="width:100%;" type="button" @click="Login">
            <hr class="hr20">
          </div>
        </el-tab-pane>
        <el-tab-pane label="扫码登录" name="second">
          <div id="code" style="text-align: center;">

          </div>
        </el-tab-pane>
      </el-tabs>

    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import elementui from 'element-ui';
  import 'element-ui/lib/theme-chalk/index.css';
  import WxLogin from '@/js/WxLogin';

  Vue.use(elementui)

  export default {
    name: "Login",
    title: "登录",
    data () {
      return {
        LoginName: "",
        Pwd: "",
        activeName: "first",
        title: ""
      }
    },
    mounted () {
      var _this = this;
      this.title = _this.$config.Title;
      var token = this.$tool.ss.Get(this.$config.LoginToken);
      var routers = this.$tool.ss.Get("Router")
      if (token && routers) {
        this.$router.push({ name: "Index" });
        this.$tool.ss.Set("TopIndex", "");
        this.$tool.ss.Set("LeftIndex", "");
      }
      window.WwLogin({
        "id": "code",  //显示二维码的容器id
        "appid": this.$config.AppId,
        "agentid": this.$config.LoginAppId,  //企业微信的cropID，在 企业微信管理端->我的企业 中查看
        "redirect_uri": encodeURI(this.$config.LoginReturn),   //重定向地址，需要进行UrlEncode
        "state": this.$config.CodeState,   //用于保持请求和回调的状态，授权请求后原样带回给企业。该参数可用于防止csrf攻击（跨站请求伪造攻击），建议企业带上该参数
        "href": "",    //自定义样式链接，企业可根据实际需求覆盖默认样式。详见文档底部FAQ

      });

      document.onkeydown = function (e) {
        if (e.key == "Enter" && !_this.$tool.ss.Get(_this.$config.Login)) {
          _this.Login();
        }

      }
    },
    methods: {
      Login () {
        if (this.LoginName == "") {
          this.$tool.System.msg("请输入账号", "提示", 1);
          return;
        }
        if (this.Pwd == "") {
          this.$tool.System.msg("请输入密码", "提示", 1);
          return;
        }
        var _this = this;
        this.Ajax.Post("/api/Login/Login", { login_Name: this.LoginName, pwd: this.Pwd }).then((res) => {
          if (res.data.role) {
            this.$tool.ss.Set(this.$config.LoginToken, JSON.stringify(res.data));
            this.$tool.ss.Set("TopIndex", "");
            this.$tool.ss.Set("LeftIndex", "");
            this.Ajax.Get("/api/Menu/GetAllRouter").then(res => {
              this.$tool.ss.Set("Router", JSON.stringify(res.data));
              this.$router.push({ name: "Index" });
            });
          } else {
            this.$tool.System.msg("登录异常！", "提示", 1);
          }
          //this.$tool.ss.Set(this.$config.Login, this.LoginName)
          //this.$tool.ss.Set(this.$config.Menu, res.Data[0].Meuns)
        });
      },
      handleClick (el) {

      }
    }
  }
</script>

<style scoped>
  * {
    font: 13px/1.5 "微软雅黑", Verdana, Helvetica, Arial, sans-serif;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -box-sizing: border-box;
    padding: 0;
    margin: 0;
    list-style: none;
    box-sizing: border-box;
  }

  .bg,
  html {
    height: 100%;
    overflow: hidden;
  }
  .bg {
    background: url(../../../assets/images/web_login_bg.jpg) no-repeat center;
    background-size: cover;
    position: fixed;
    width: 100%;
  }
  a {
    color: #27a9e3;
    text-decoration: none;
    cursor: pointer;
  }
  .login {
    margin: 150px auto 0 auto;
    min-height: 420px;
    max-width: 520px;
    padding: 40px;
    background-color: #ffffff;
    margin-left: auto;
    margin-right: auto;
    border-radius: 4px;
    /* overflow-x: hidden; */
    box-sizing: border-box;
  }
  a.logo {
    display: block;
    height: 58px;
    width: 167px;
    margin: 0 auto 30px auto;
    background-size: 167px 42px;
  }
  .message {
    margin: 10px 0 0 -58px;
    padding: 18px 10px 18px 60px;
    background: #27a9e3;
    position: relative;
    color: #fff;
    font-size: 16px;
  }
  #darkbannerwrap {
    background: url(../../../assets/images/aiwrap.png);
    width: 18px;
    height: 10px;
    margin: 0 0 20px -58px;
    position: relative;
  }

  input[type="text"],
  input[type="file"],
  input[type="password"],
  input[type="email"],
  select {
    border: 1px solid #dcdee0;
    vertical-align: middle;
    border-radius: 3px;
    height: 50px;
    padding: 0px 16px;
    font-size: 14px;
    color: #555555;
    outline: none;
    width: 100%;
  }
  input[type="text"]:focus,
  input[type="file"]:focus,
  input[type="password"]:focus,
  input[type="email"]:focus,
  select:focus {
    border: 1px solid #27a9e3;
  }

  input[type="submit"],
  input[type="button"] {
    display: inline-block;
    vertical-align: middle;
    padding: 12px 24px;
    margin: 0px;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    color: #ffffff;
    background-color: #27a9e3;
    border-radius: 3px;
    border: none;
    -webkit-appearance: none;
    outline: none;
    width: 100%;
  }
  hr.hr15 {
    height: 30px;
    border: none;
    margin: 0px;
    padding: 0px;
    width: 100%;
  }
  hr.hr20 {
    height: 20px;
    border: none;
    margin: 0px;
    padding: 0px;
    width: 100%;
  }

  .copyright {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.85);
    display: block;
    position: absolute;
    bottom: 15px;
    right: 15px;
  }
</style>

